export class BrowserNavigationHelper {

  static openBlankTabForAsyncResult(): Window | null {
    return window.open('about:blank', '_blank');
  }

  static navigateOpenedTabOrSameWindow(openedTab: Window | null, url: string): void {
    if (openedTab) {
      openedTab.location.href = url;
    } else {
      window.location.href = url;
    }
  }

  static closeTabIfOpen(openedTab: Window | null): void {
    if (!openedTab) {
      return;
    }
    try {
      openedTab.close();
    } catch (e) {
      // ignore
    }
  }
}
